// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-builder[data-v-43798231]{margin:0 auto;max-width:800px;padding:64px 16px}.form-steps[data-v-43798231]{margin-top:32px}.form-fields[data-v-43798231]{display:grid;grid-template-columns:repeat(12,1fr);grid-gap:32px 16px;gap:32px 16px}.form-navigation[data-v-43798231]{display:flex;gap:16px;justify-content:center;margin-top:32px}.error-message[data-v-43798231]{color:var(--color-error);display:block;font-size:12px;margin-top:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
